import React from 'react';
import DataResource from './../../../common/v4/DataResource';
import Panel from './../../../common/layout/Panel';
import Tabs from './../../../common/Tabs';

const tabs = [
    {
        link: '/clients/companies',
        name: 'Companies'
    },
    {
        link: '/clients/branches',
        name: 'Branches'
    },
    {
        link: '/clients/teams',
        name: 'Teams'
    }
] 

const Teams = (props) => {
    const data = {
        url: '/admin/clients/teams',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: '/clients/teams/{id}',
        userfilter:[
            {
                source: 'name',
                label: 'Name',
                type: 'text',
                default: ''
            },
            {
                source: 'company_id',
                label: 'Company',
                type: 'select',
                options: props.metadata?.companies?.map(c => ({ value: c.id, label: c.name })) || [],
                default: ''
            },
            {
                source: 'branch_id',
                label: 'Branch',
                type: 'select',
                options: props.metadata?.branches?.map(b => ({ value: b.id, label: b.name })) || [],
                default: ''
            },
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Name',
                source: 'name',
                type: 'text',
                editable: true,
                default: '',
                placeholder: 'Team Name'
            },
            {
                label: 'Company',
                source: 'company_id',
                type: 'select'
               
            },
            {
                label: 'Branch',
                source: 'branch_id',
                type: 'select'
            },
            {
                label: 'Created',
                source: 'created_at',
                type: 'datetime',
                editable: false,
                visible: true
            },
            {
                label: 'Delete',
                type: 'delete'
            }
        ]
    };
    return (
        <Panel title="Teams">
            <div>
                <Tabs tabs={tabs} />
                <DataResource
                    data={data}
                    addButtonText="Create Team"
                    addButtonLink="/clients/teams/create"
                    {...props}
                />
            </div>
        </Panel>
    );
};

export default Teams; 